/**
 * PanelsOnlyLanding - what `/` shows a person whose roles open no module in
 * this app (e.g. Risk Management or SysOps only). Their rail is empty, and the
 * full Home would offer New Account, which their roles cannot use. Instead:
 * say plainly where their work is and link the panels their roles can open
 * (same list and gates as the user menu). Bill 2026-10-07: Risk will not work
 * inside the Teams app going forward.
 */
import { ExternalLink } from '@retail-ops/panel-shell/fi';
import { Link } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import { panelLinksForRoles, openInBrowser } from '@/constants/panelLinks';

export function PanelsOnlyLanding(): JSX.Element {
  const { user } = useAuth();
  const links = panelLinksForRoles(user?.roles ?? []);
  const first = user?.displayName?.split(' ')[0];

  return (
    <div className="home-page" style={{ maxWidth: 640, margin: '0 auto', padding: 'var(--sp-8) var(--sp-4)' }}>
      <section className="home-card" aria-labelledby="panels-only-h">
        <h1 id="panels-only-h" className="home-card__title" style={{ fontSize: 20 }}>
          {first ? `Hi ${first} - your work is in the panels` : 'Your work is in the panels'}
        </h1>
        <p style={{ color: 'var(--ink-700)', margin: 'var(--sp-3) 0' }}>
          This app is where branch staff open accounts. Your role does not use it - your settings,
          queues and reports are in the panels below. They open in your browser.
        </p>
        {links.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-2)' }}>
            {links.map((p) => (
              <button key={p.url} type="button" className="btn btn-primary"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}
                onClick={() => openInBrowser(p.url)}>
                {p.label} <ExternalLink size={14} aria-hidden />
              </button>
            ))}
          </div>
        ) : (
          <p style={{ color: 'var(--ink-600)' }}>
            Your account has no role that uses this app or a panel yet. Ask an administrator to check
            your access in the Admin panel (Identity &amp; Access).
          </p>
        )}
        <p style={{ color: 'var(--ink-500)', fontSize: 12.5, marginTop: 'var(--sp-4)' }}>
          Something wrong? Use the lifebuoy in the bottom-left corner, or see <Link to="/help">Help</Link>.
        </p>
      </section>
    </div>
  );
}

export default PanelsOnlyLanding;
